import { render, staticRenderFns } from "./PaxelRecycle.vue?vue&type=template&id=c1395c6c&"
import script from "./PaxelRecycle.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports